import TemplateOriginal, { meta as metaOriginal, tema as temaOriginal } from "./TemplateOriginal";
import TemplateUniversal, { PALETTES } from "./TemplateUniversal";

// ─── Metadados de exibição (lista de templates) ───────────────────────────────

const METAS = {
  minimalista: { id: "minimalista", label: "Minimalista",     emoji: "🤍", desc: "Branco, limpo e elegante"          },
  elegante:    { id: "elegante",    label: "Elegante",         emoji: "✨", desc: "Fundo escuro, detalhes dourados"   },
  moderno:     { id: "moderno",     label: "Moderno",          emoji: "💜", desc: "Roxo intenso, visual bold"         },
  festivo:     { id: "festivo",     label: "Festivo",          emoji: "🎉", desc: "Colorido e animado"                },
  monica:      { id: "monica",      label: "Turma da Mônica",  emoji: "🐰", desc: "Rosa e amarelo pastel, clássico"   },
  frozen:      { id: "frozen",      label: "Frozen",           emoji: "❄️", desc: "Azul gelado, mágico e elegante"    },
  stitch:      { id: "stitch",      label: "Stitch",           emoji: "🌺", desc: "Azul tropical, Hawaii e divertido" },
  churrasco:   { id: "churrasco",   label: "Churrasco",        emoji: "🔥", desc: "Tons de brasa, festa ao ar livre"  },
  futebol:     { id: "futebol",     label: "Futebol",          emoji: "⚽", desc: "São Paulo como padrão"             },
};

export const FUTEBOL_TEMPLATE_ID = "futebol";
export const FUTEBOL_VARIANTS = [
  { id: "futebol-tricolor", label: "São Paulo camisa 2", desc: "Vermelho e preto" },
  { id: "futebol-cruzeiro", label: "Cruzeiro", desc: "Azul estrelado" },
  { id: "futebol-cruzeiro-raposa", label: "Cruzeiro Raposa", desc: "Mascote e escudo" },
  { id: "futebol-atletico", label: "Atlético MG", desc: "Alvinegro" },
  { id: "futebol-atletico-homenagem", label: "Atlético Homenagem", desc: "Galo listrado" },
];

const HIDDEN_UNIVERSAL_IDS = FUTEBOL_VARIANTS.map((variant) => variant.id);

export function isFutebolTemplateId(templateId) {
  return templateId === FUTEBOL_TEMPLATE_ID || HIDDEN_UNIVERSAL_IDS.includes(templateId);
}

export function getTemplateGroupId(templateId) {
  return isFutebolTemplateId(templateId) ? FUTEBOL_TEMPLATE_ID : templateId;
}

// ─── Temas do formulário RSVP (usados em RsvpForm para estilização) ───────────

const TEMAS_MAP = {
  minimalista: {
    sectionBg:   "#f5f5f5",
    recadoBg:    "#f0f0f0",
    titulo:      { color: "#111", textShadow: "none" },
    btnAdd:      { background: "#111", color: "white", borderRadius: 4 },
    itemBg:      "white",
    numeroBg:    "#333",
    numeroColor: "white",
    labelColor:  "#444",
    inputExtra:  { borderColor: "#ccc" },
    submit:      { background: "#111", boxShadow: "0 5px 15px rgba(0,0,0,0.15)", borderRadius: 4, letterSpacing: "0.5px" },
  },
  elegante: {
    sectionBg:   "rgba(255,255,255,0.06)",
    recadoBg:    "rgba(255,255,255,0.04)",
    titulo:      { color: "#c9a84c", textShadow: "none" },
    btnAdd:      { background: "linear-gradient(45deg,#c9a84c,#b8923a)", color: "#1a1a1a" },
    itemBg:      "#252525",
    numeroBg:    "#c9a84c",
    numeroColor: "#1a1a1a",
    labelColor:  "#c9a84c",
    inputExtra:  { background: "#2a2a2a", borderColor: "#3a3a3a", color: "#f5f0e8" },
    submit:      { background: "linear-gradient(45deg,#c9a84c,#b8923a)", boxShadow: "0 5px 15px rgba(201,168,76,0.35)", color: "#1a1a1a", borderRadius: 4 },
  },
  moderno: {
    sectionBg:   "#eef2ff",
    recadoBg:    "#e8edff",
    titulo:      { color: "#4f46e5", textShadow: "none" },
    btnAdd:      { background: "#4f46e5", color: "white" },
    itemBg:      "white",
    numeroBg:    "#4f46e5",
    numeroColor: "white",
    labelColor:  "#4f46e5",
    inputExtra:  { borderColor: "#c7d2fe" },
    submit:      { background: "linear-gradient(45deg,#4f46e5,#3730a3)", boxShadow: "0 5px 15px rgba(79,70,229,0.4)", borderRadius: 25 },
  },
  festivo: {
    sectionBg:   "rgba(255,107,107,0.08)",
    recadoBg:    "rgba(107,207,127,0.1)",
    titulo:      { color: "#c0392b", textShadow: "none" },
    btnAdd:      { background: "linear-gradient(45deg,#ff6b6b,#ffd93d)", color: "white" },
    itemBg:      "#fffdf5",
    numeroBg:    "#ff6b6b",
    numeroColor: "white",
    labelColor:  "#555",
    inputExtra:  {},
    submit:      { background: "linear-gradient(135deg,#ff6b6b,#ffd93d)", boxShadow: "0 5px 15px rgba(255,107,107,0.4)", borderRadius: 25 },
  },
  monica: {
    sectionBg:   "rgba(244,144,154,0.1)",
    recadoBg:    "rgba(253,230,138,0.3)",
    titulo:      { color: "#c97b84", textShadow: "none" },
    btnAdd:      { background: "#f4909a", color: "white" },
    itemBg:      "white",
    numeroBg:    "#fde68a",
    numeroColor: "#7c2d12",
    labelColor:  "#7c2d12",
    inputExtra:  { borderColor: "#fde68a" },
    submit:      { background: "linear-gradient(45deg,#f4909a,#e07880)", boxShadow: "0 5px 15px rgba(244,144,154,0.4)", borderRadius: 25 },
  },
  frozen: {
    sectionBg:   "rgba(74,154,186,0.1)",
    recadoBg:    "rgba(202,240,248,0.35)",
    titulo:      { color: "#1b4965", textShadow: "none" },
    btnAdd:      { background: "linear-gradient(45deg,#1b4965,#4a9aba)", color: "white" },
    itemBg:      "rgba(202,240,248,0.18)",
    numeroBg:    "#4a9aba",
    numeroColor: "white",
    labelColor:  "#1b4965",
    inputExtra:  { borderColor: "#90e0ef" },
    submit:      { background: "linear-gradient(45deg,#1b4965,#4a9aba)", boxShadow: "0 5px 15px rgba(27,73,101,0.35)", borderRadius: 4 },
  },
  stitch: {
    sectionBg:   "rgba(0,150,199,0.08)",
    recadoBg:    "rgba(144,224,239,0.2)",
    titulo:      { color: "#0077b6", textShadow: "none" },
    btnAdd:      { background: "linear-gradient(45deg,#0077b6,#00b4d8)", color: "white" },
    itemBg:      "rgba(202,240,248,0.2)",
    numeroBg:    "#0096c7",
    numeroColor: "white",
    labelColor:  "#023e8a",
    inputExtra:  { borderColor: "#90e0ef" },
    submit:      { background: "linear-gradient(45deg,#023e8a,#0077b6)", boxShadow: "0 5px 15px rgba(2,62,138,0.4)", borderRadius: 25 },
  },
  churrasco: {
    sectionBg:   "rgba(249,115,22,0.08)",
    recadoBg:    "rgba(217,119,6,0.1)",
    titulo:      { color: "#c2410c", textShadow: "none" },
    btnAdd:      { background: "linear-gradient(45deg,#ea580c,#c2410c)", color: "white" },
    itemBg:      "white",
    numeroBg:    "#ea580c",
    numeroColor: "white",
    labelColor:  "#7c2d12",
    inputExtra:  { borderColor: "#fed7aa" },
    submit:      { background: "linear-gradient(45deg,#c2410c,#9a3412)", boxShadow: "0 5px 15px rgba(194,65,12,0.4)", borderRadius: 8 },
  },
  futebol: {
    sectionBg:   "rgba(220,38,38,0.08)",
    recadoBg:    "rgba(17,17,17,0.05)",
    titulo:      { color: "#111111", textShadow: "none" },
    btnAdd:      { background: "linear-gradient(45deg,#111111,#dc2626)", color: "white" },
    itemBg:      "white",
    numeroBg:    "#dc2626",
    numeroColor: "white",
    labelColor:  "#111111",
    inputExtra:  { borderColor: "#fecaca" },
    submit:      { background: "linear-gradient(45deg,#111111,#dc2626)", boxShadow: "0 5px 15px rgba(17,17,17,0.28)", borderRadius: 8 },
  },
  "futebol-tricolor": {
    sectionBg:   "rgba(220,38,38,0.1)",
    recadoBg:    "rgba(17,17,17,0.06)",
    titulo:      { color: "#b91c1c", textShadow: "none" },
    btnAdd:      { background: "linear-gradient(45deg,#dc2626,#111111)", color: "white" },
    itemBg:      "white",
    numeroBg:    "#111111",
    numeroColor: "white",
    labelColor:  "#111111",
    inputExtra:  { borderColor: "#fecaca" },
    submit:      { background: "linear-gradient(45deg,#dc2626,#111111)", boxShadow: "0 5px 15px rgba(220,38,38,0.32)", borderRadius: 8 },
  },
  "futebol-cruzeiro": {
    sectionBg:   "rgba(29,78,216,0.08)",
    recadoBg:    "rgba(191,219,254,0.24)",
    titulo:      { color: "#1d4ed8", textShadow: "none" },
    btnAdd:      { background: "linear-gradient(45deg,#1d4ed8,#0f172a)", color: "white" },
    itemBg:      "white",
    numeroBg:    "#1d4ed8",
    numeroColor: "white",
    labelColor:  "#1e40af",
    inputExtra:  { borderColor: "#bfdbfe" },
    submit:      { background: "linear-gradient(45deg,#1d4ed8,#0f172a)", boxShadow: "0 5px 15px rgba(29,78,216,0.35)", borderRadius: 8 },
  },
  "futebol-cruzeiro-raposa": {
    sectionBg:   "rgba(37,69,150,0.1)",
    recadoBg:    "rgba(56,189,248,0.16)",
    titulo:      { color: "#254596", textShadow: "none" },
    btnAdd:      { background: "linear-gradient(45deg,#254596,#0ea5e9)", color: "white" },
    itemBg:      "white",
    numeroBg:    "#254596",
    numeroColor: "white",
    labelColor:  "#17347f",
    inputExtra:  { borderColor: "#93c5fd" },
    submit:      { background: "linear-gradient(45deg,#254596,#0ea5e9)", boxShadow: "0 5px 15px rgba(37,69,150,0.35)", borderRadius: 8 },
  },
  "futebol-atletico": {
    sectionBg:   "rgba(17,17,17,0.07)",
    recadoBg:    "rgba(255,208,0,0.1)",
    titulo:      { color: "#111111", textShadow: "none" },
    btnAdd:      { background: "linear-gradient(45deg,#111111,#2a2a2a)", color: "white" },
    itemBg:      "white",
    numeroBg:    "#111111",
    numeroColor: "white",
    labelColor:  "#27272a",
    inputExtra:  { borderColor: "#d4d4d8" },
    submit:      { background: "linear-gradient(45deg,#111111,#2a2a2a)", boxShadow: "0 5px 15px rgba(17,17,17,0.35)", borderRadius: 8 },
  },
  "futebol-atletico-homenagem": {
    sectionBg:   "rgba(17,17,17,0.06)",
    recadoBg:    "rgba(239,68,68,0.08)",
    titulo:      { color: "#111111", textShadow: "none" },
    btnAdd:      { background: "linear-gradient(45deg,#111111,#ef3b25)", color: "white" },
    itemBg:      "white",
    numeroBg:    "#111111",
    numeroColor: "white",
    labelColor:  "#27272a",
    inputExtra:  { borderColor: "#d4d4d8" },
    submit:      { background: "linear-gradient(45deg,#111111,#ef3b25)", boxShadow: "0 5px 15px rgba(17,17,17,0.32)", borderRadius: 8 },
  },
};

// ─── IDs que usam TemplateUniversal ───────────────────────────────────────────

const UNIVERSAL_IDS = Object.keys(METAS);
const ALL_UNIVERSAL_IDS = [...UNIVERSAL_IDS, ...HIDDEN_UNIVERSAL_IDS];

// ─── Exports públicos ─────────────────────────────────────────────────────────

/** Map id → componente React  (usado em EventoPublico para renderizar) */
export const TEMPLATES = {
  original: TemplateOriginal,
  ...Object.fromEntries(ALL_UNIVERSAL_IDS.map(id => [id, TemplateUniversal])),
};

/** Map id → objeto de tema     (usado em RsvpForm para estilização) */
export const TEMAS = {
  original: temaOriginal,
  ...TEMAS_MAP,
};

/** Array de metadados ordenado (usado em EventoForm para listar opções) */
export const TEMPLATES_LIST = [
  metaOriginal,
  ...UNIVERSAL_IDS.map(id => METAS[id]),
];

/** Palettes de cada tema universal (usado em LayoutsManager) */
export { PALETTES };
